<!--
  Forbrukerrådet - Kommunetesten
  @link https://gitlab01.copyleft.no/FBR/kommunetesten-new
  @author Anders Evenrud <anders.evenrud@copyleft.no>
-->
<template>
  <div class="button">
    <a :href="href" :target="target">
      <slot />
    </a>
  </div>
</template>

<style lang="scss" scoped>
@import "../assets/variables";
@import "../assets/mixins";

.button {
  @include input();
  text-align: center;
  font-weight: bold;
  padding: 0;
  display: flex;
  flex-align: center;
  justify-content: center;
  cursor: pointer;

  a {
    color: $font-color !important;
    display: block;
    padding: 1.5em;
    width: 100%;
    text-decoration: none;
  }

  span {
    padding-left: 0.5em;
  }
}
</style>

<script>
export default {
  props: {
    href: {
      type: String,
      default: 'about:blank'
    },

    target: {
      type: String
    }
  },

  data () {
    return {
    }
  },

  methods: {
    onClick (ev) {
      this.$emit('onclick', ev)
    }
  }
}
</script>
